import { State } from '../interfaces/state';

export const getDefaultState = (): State => {
  return {
    state: 'New York',
    abbr: 'us-ny',
  };
};
